const SummaryElement = ({
  code,
  title,
  value,
  unit,
}: {
  code: string
  title: string
  value: number
  unit: string
}) => {
  return (
    <tr className="flex w-full px-5">
      <td className="flex-initial font-bold max-w-[110px] min-w-[85px] mr-3">
        <span>{code}</span>
      </td>
      <td className="flex-1 font-semibold">
        <span>{title}</span>
      </td>
      <td className="text-right">
        <span>
          {value} {unit || "ks"}
        </span>
      </td>
    </tr>

    // <div className="flex flex-row justify-between">
    //   <h1>{code}</h1>
    //   <h1>{title}</h1>
    //   <h1>{value}</h1>
    //   <h1>{unit}</h1>
    // </div>
  )
}

export default SummaryElement
